import { useContext } from "react"

import { ComponentCreationContext } from "~/pages/Brand/CommunicationStudio/contexts/componentCreation/ComponentCreationContext"

export const useComponentCreation = () => {
  const ctx = useContext(ComponentCreationContext)
  if (!ctx) {
    throw new Error(
      "useComponentCreation must be used within a ComponentCreationProvider"
    )
  }
  return ctx
}
